import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "../base-http.service";
import { Injectable } from "@angular/core";
import { UserService } from "../user/user.service";
import { ProgressBarService } from "../../modules/shared/progress-bar/progress-bar.service";
import { MessageService } from "../../modules/shared/message/message.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class MissingYoursService extends BaseHttpService {

  constructor(protected http: HttpClient,
              protected userService: UserService,
              protected translateService: TranslateService,
              protected progressBarService: ProgressBarService,
              protected messageService: MessageService) {
    super(http, userService, translateService, progressBarService, messageService);
  }

  async saveApiVote(name: string, email: string, remarks: string, newsletter: boolean, appFrom: string, appTo: string): Promise<boolean> {
    return (await this.post<boolean>("unauthenticated/apis/vote", {saveCombiVote: {name, email, remarks, newsletter, appFrom, appTo}})).success;
  }
}
